/**
 * 会员管理系统 - 套餐分类管理 API
 *
 * 提供套餐分类的 CRUD 操作
 */

import httpRequest from '@/utils/api'
import type {
  PlanCategory,
  CreateCategoryRequest,
  UpdateCategoryRequest,
  CategoryListResponseData,
  CategoryDetailResponseData,
  DeleteCategoryResponseData,
} from '@/types/membership/category'

enum API {
  categories = '/admin/plan-categories',
}

/**
 * 获取所有套餐分类
 *
 * @returns 套餐分类列表响应
 */
export const getAllCategoriesAPI = () => {
  return httpRequest.get<CategoryListResponseData>({
    url: API.categories,
  })
}

/**
 * 根据 ID 获取套餐分类
 *
 * @param categoryId 分类 ID
 * @returns 套餐分类详情响应
 */
export const getCategoryByIdAPI = (categoryId: number) => {
  return httpRequest.get<CategoryDetailResponseData>({
    url: `${API.categories}/${categoryId}`,
  })
}

/**
 * 创建套餐分类
 *
 * @param data 创建套餐分类请求数据
 * @returns 套餐分类详情响应
 */
export const createCategoryAPI = (data: CreateCategoryRequest) => {
  return httpRequest.post<PlanCategory>({
    url: API.categories,
    data,
  })
}

/**
 * 更新套餐分类
 *
 * @param categoryId 分类 ID
 * @param data 更新套餐分类请求数据
 * @returns 套餐分类详情响应
 */
export const updateCategoryAPI = (categoryId: number, data: UpdateCategoryRequest) => {
  return httpRequest.put<PlanCategory>({
    url: `${API.categories}/${categoryId}`,
    data,
  })
}

/**
 * 删除套餐分类
 *
 * @param categoryId 分类 ID
 * @returns 删除响应
 */
export const deleteCategoryAPI = (categoryId: number) => {
  return httpRequest.delete<DeleteCategoryResponseData>({
    url: `${API.categories}/${categoryId}`,
  })
}

